import {
  CREATED_NEW_TOOL,
  UPDATE_ALL_TOOLS,
  UPDATE_MANUFATURERS_AND_SHIP_LOCATIONS,
  UPDATE_ALL_TOOL_NAMES,
  UPDATE_ALL_MULTI_SELECTED_TOOLS,
  UPDATE_ALL_MULTI_SELECTED_TOOL_NAMES,
  TOOLS_CHECKOUT_DONE,
  TOOLS_CHECKIN_DONE,
  UPDATE_CURRENT_TOOLS,
  UPDATE_MULTI_SELECTED_TOOL_NAMES_DETAILS,
  UPDATE_SINGLE_TOOL_DONE,
  UPDATE_TOOL_GROUP_DONE,
  UPDATE_SIMPLE_TOOL_DETAILS,
  DELETE_TOOL_GROUP_DONE,
  TOOLS_TRANSFER_DONE,
  DELETE_TOOL_DONE,
} from "../actions/";

const toolsReducer = (
  state = {
    // initial state
    allTools: [],
    toolGroupList: [],
    multiSelectedToolNames: [],
    multiSelectedToolNamesDetails: [],
    multiSelectedTools: [],
    manufacturers: [],
    storageLocations: [],
    simpleToolDetails: [],
    toolNames: [],
    currentTools: [],
    newToolCreated: false,
    singleToolUpdateDone: false,
    groupToolUpdateDone: false,
    deleteToolDone: false,
    toolsCheckoutDone: false,
    toolsTransferDone: false,
    toolsCheckInDone: false,
  },
  action
) => {
  switch (action.type) {
    case UPDATE_ALL_TOOLS:
      return {
        ...state,
        // allTools: [...action.allTools],
        toolGroupList: [...action.toolGroupList],
        newToolCreated: false,
        singleToolUpdateDone: false,
        groupToolUpdateDone: false,
        deleteToolDone: false,
        toolsCheckoutDone: false,
        toolsTransferDone: false,
        toolsCheckInDone: false,
        groupToolDeleteDone: false,
      };
    case CREATED_NEW_TOOL:
      return {
        ...state,
        newToolCreated: true,
      };
    case UPDATE_SINGLE_TOOL_DONE:
      return {
        ...state,
        singleToolUpdateDone: true,
      };
    case UPDATE_TOOL_GROUP_DONE:
      return {
        ...state,
        groupToolUpdateDone: true,
      };
    case DELETE_TOOL_GROUP_DONE:
      return {
        ...state,
        groupToolDeleteDone: true,
      };
    case DELETE_TOOL_DONE:
      return {
        ...state,
        deleteToolDone: true,
      };
    case UPDATE_MANUFATURERS_AND_SHIP_LOCATIONS:
      return {
        ...state,
        manufacturers: [...action.manufacturers],
        storageLocations: [...action.storageLocations],
      };
    case UPDATE_ALL_TOOL_NAMES:
      return {
        ...state,
        toolNames: [...action.toolNames],
        newToolCreated: false,
        singleToolUpdateDone: false,
        groupToolUpdateDone: false,
        toolsCheckoutDone: false,
        toolsTransferDone: false,
        toolsCheckInDone: false,
        groupToolDeleteDone: false,
        deleteToolDone: false,
      };
    case UPDATE_CURRENT_TOOLS:
      return {
        ...state,
        currentTools: [...action.currentTools],
      };
    case UPDATE_SIMPLE_TOOL_DETAILS:
      return {
        ...state,
        simpleToolDetails: [...action.simpleToolDetails],
      };
    case UPDATE_MULTI_SELECTED_TOOL_NAMES_DETAILS:
      return {
        ...state,
        multiSelectedToolNamesDetails: [
          ...action.multiSelectedToolNamesDetails,
        ],
      };
    case UPDATE_ALL_MULTI_SELECTED_TOOL_NAMES:
      return {
        ...state,
        multiSelectedToolNames: [...action.multiSelectedToolNames],
      };
    case UPDATE_ALL_MULTI_SELECTED_TOOLS:
      return {
        ...state,
        multiSelectedTools: [...action.multiSelectedTools],
      };
    case TOOLS_CHECKOUT_DONE:
      return {
        ...state,
        toolsCheckoutDone: true,
      };
    case TOOLS_CHECKIN_DONE:
      return {
        ...state,
        toolsCheckInDone: true,
      };
    case TOOLS_TRANSFER_DONE:
      return {
        ...state,
        toolsTransferDone: true,
      };

    default:
      return state;
  }
};

export default toolsReducer;
